<template>
  <v-app light>
    <app-toolbar v-if="showToolbar"/>
    <navigation-drawer v-if="showNavigationDrawer"/>
    <v-content>
      <router-view/>
    </v-content>
    <app-snackbar ref="snackbar"/>
  </v-app>
</template>

<script>
import appToolbar from '@/components/core/app-toolbar'
import appSnackbar from '@/components/core/app-snackbar'
import navigationDrawer from '@/components/core/navigation-drawer'

export default {
  name: 'App',
  components: {
    appSnackbar,
    appToolbar,
    navigationDrawer
  },
  data () {
    return {
      //
    }
  },
  computed: {
    showNavigationDrawer () {
      return this.$store.state.route.name !== 'uploadPage'
    },
    showToolbar () {
      return this.$store.state.route.name !== 'uploadPage'
    }
  },
  mounted () {
    this.$root.$snackbar = this.$refs.snackbar
  }
}
</script>
